import styled from "styled-components";

// Shown in place of a course form field once it can no longer be edited
export const InfoBox = styled.div`
  background-color: #f9f9f9;
  border-left: 4px solid #2196f3;
  padding: 16px;
  margin-bottom: 16px;
`;

export const InfoLabel = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
`;

export const InfoValue = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #000;
`;
